<template>
  <div class="page-container">
    <div class="page-title-container">
      <h1 class="title-text">Oh no! Page not found 😨</h1>
    </div>

    <div class="features-container">
      <div class="box" style="text-align: center;">
        <p>Sorry, this page doesn't exist. Go to <router-link to="/">JobBoardy</router-link> and start sending job offers.</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  created() {
    window.scrollTo(0, 0);
  },
};
</script>

<style></style>
